/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { config } from '../../../../../../components/dashboards/config';

const Style = styled.div`
  border-top: 1px solid ${config.BORDER_COLOR};
  padding: 15px ${config.PADDING}px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  &.no-borders {
    border-top: 0px;
    padding-top: 0px;
  }

  h6 {
    color: #595959;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0.5em;
  }

  .metrics {
    padding-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    &.align-center {
      justify-content: center;
    }

    .metric {
      display: flex;
      cursor: pointer;
      transition: .4s opacity;

      .identifier-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 6px;
      }
      
      .identifier {
        width: 10px;
        height: 10px;
        
        &.rounded {
          border-radius: 2px;
        }

        &.rounded-full {
          border-radius: 100%;
        }
      }

      .metric-title {
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          line-height: 1.2em;
          font-size: 12px;
          margin-bottom: 0px !important;
          -webkit-user-select: none;        
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none; 
        }
      }
      
      &.metric-disabled {
        opacity: .5;
      }

      &.metric-grid {
        flex: 1;
        min-width: fit-content;
      }

      &.metric-distribution {
        min-width: 100px;
      }
    }
  }
`;

const Metrics = ({
  title = '',
  metricsValues = [],
  metricGrid = false,
  reversed = false,
  roundedIdentifiers = false,
  noBorders = false,
  isEmpty = false,
  distributionStakeholders = false,
  setMetricsValues = () => { },
  alignCenter = false,
  fullRoundedIdentifiers = false,
  padding = null,
  t = (t) => t,
}) => {
  const toggleItem = useCallback((item) => {
    if (!isEmpty) {
      setMetricsValues((prev) => prev.map((p) => {
        if (p.label === item.label) {
          return { ...p, toggled: !p.toggled, };
        }
        return p;
      }));
    }
  }, [isEmpty]);

  const valuesToMap = useMemo(() => reversed ? metricsValues.slice().reverse() : metricsValues, [metricsValues, reversed]);
  
  const renderValues = useMemo(() => valuesToMap.filter((r) => r.type !== 'empty').map((val, i) => (
    <div
      className={
        formatClassname([
          'metric',
          !val.toggled && 'metric-disabled',
          metricGrid && 'metric-grid',
          distributionStakeholders && 'metric-distribution'
        ])
      }
      key={i.toString()}
      onClick={() => toggleItem(val)}
    >
      <div className="identifier-container">
        <div
          className={
            formatClassname([
              'identifier',
              roundedIdentifiers && 'rounded',
              fullRoundedIdentifiers && 'rounded-full',
            ])
          }
          style={{ background: val.color }}
        />
      </div>
      <div className="metric-title">
        <p>{val.labelToShow ? val.labelToShow : t(val.label)}</p>
      </div>
    </div>
  )), [valuesToMap, roundedIdentifiers, toggleItem, metricGrid, t]);

  return <Style
    style={{ padding }}
    className={formatClassname([noBorders && 'no-borders'])}
  >
    {title && (
      <h6>{title}</h6>
    )}
    <div className={formatClassname(["metrics", alignCenter && 'align-center'])}>
      {renderValues}
    </div>
  </Style>;
}

export default Metrics;
